import { View } from 'foundations-components/components/View';
import { HR } from 'foundations-components/transitional/components/HR';
import PaymentMethodOnFile from '../PaymentMethodOnFile';
import ClickToCancelCheckbox from './ClickToCancelCheckbox';
import MaybeCancellationAndRefundPolicies from './MaybeCancellationAndRefundPolicies';
import TermsOfService from './TermsOfService';
import { useMerchantTermsOfServiceMessage } from '../../hooks/useMerchantTermsOfServiceMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TermsOfServiceInputs = ({
  shouldShowTermsOfServiceAcknowledgementCheckbox,
  policySettings,
  shouldDisplayPMOFCheckbox,
  isZeroCheckout,
  shouldShowClickToCancelCheckbox
}) => {
  const translationMessageKey = useMerchantTermsOfServiceMessage();
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "terms-of-service-inputs",
    children: [/*#__PURE__*/_jsx(HR, {}), shouldDisplayPMOFCheckbox && /*#__PURE__*/_jsx(PaymentMethodOnFile, {}), shouldShowClickToCancelCheckbox && /*#__PURE__*/_jsx(ClickToCancelCheckbox, {}), shouldShowTermsOfServiceAcknowledgementCheckbox && /*#__PURE__*/_jsxs("div", {
      "data-test-id": "terms-of-service-acknowledgement-container",
      children: [/*#__PURE__*/_jsx(TermsOfService, {
        translationMessageKey: translationMessageKey,
        isZeroCheckout: isZeroCheckout
      }), policySettings && /*#__PURE__*/_jsx(MaybeCancellationAndRefundPolicies, {
        policySettings: policySettings
      })]
    })]
  });
};
export default TermsOfServiceInputs;